import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonCodePipe } from './common-code.pipe';
import { ValidatorMessagePipe } from './validator-message.pipe';
import { CountryCodePipe } from './country-code.pipe';
import { CategoryCodePipe } from './category-code.pipe';
import { PriceNumberPipe } from './price-number.pipe';
import { TPipe } from './t.pipe';
import { SafeHtmlPipe } from './safe-html.pipe';
import { SalesRatePipe } from './sales-rate.pipe';
import { BadgesPipe } from './badges.pipe';
import { CategoryPipe } from './category.pipe';
import { DateFormatPipe } from './date-format.pipe';
import { DifferencePipe } from './difference.pipe';
import { CategoryNamePipe } from './category-name.pipe';
import { HighlightPipe } from './highlight.pipe';
import { RocketDeadlineDatePipe } from './rocket-deadline-date.pipe';
import { PromotionRemainDatePipe } from './promotion-remain-date.pipe';

const PIPES = [
  PriceNumberPipe,
  CommonCodePipe,
  CategoryCodePipe,
  CategoryNamePipe,
  ValidatorMessagePipe,
  CountryCodePipe,
  SalesRatePipe,
  TPipe,
  HighlightPipe,
  RocketDeadlineDatePipe,
  PromotionRemainDatePipe,
  SafeHtmlPipe,
  BadgesPipe,
  CategoryPipe,
  DateFormatPipe,
  DifferencePipe,
];

@NgModule({
  declarations: [...PIPES],
  imports: [CommonModule],
  exports: [...PIPES],
})
export class PipesModule {}
